<script setup>
import { useI18n } from 'vue-i18n';
import { Switch as PolarisSwitch } from 'next/polaris/ui/switch';

const emit = defineEmits(['change']);

const { t } = useI18n();

const modelValue = defineModel({
  type: Boolean,
  default: false,
});

const updateValue = value => {
  modelValue.value = value;
  emit('change', value);
};
</script>

<template>
  <PolarisSwitch
    :model-value="modelValue"
    :aria-label="t('SWITCH.TOGGLE')"
    @update:model-value="updateValue"
  />
</template>
